// src/pages/ServicesPage.js
import React from 'react';
import './ServicesPage.css';
import { FaHome, FaBuilding, FaIndustry } from 'react-icons/fa';

const clickSound = '/mixkit-modern-technology-select-3124.wav'; // sound in public folder

const services = [
  {
    title: 'Residential Scaffolding',
    description: 'Safe and reliable scaffolding for home renovations and construction.',
    icon: <FaHome />
  },
  {
    title: 'Commercial Scaffolding',
    description: 'Robust scaffolding solutions tailored for commercial buildings.',
    icon: <FaBuilding />
  },
  {
    title: 'Industrial Scaffolding',
    description: 'Heavy-duty scaffolding for industrial and large-scale projects.',
    icon: <FaIndustry />
  }
];

const ServicesPage = () => {
  const playClick = () => {
    const audio = new Audio(clickSound);
    audio.play();
  };

  return (
    <div className="services-page">

      <header className="services-header">
        <h1>Our Services</h1>
        <p>Explore the wide range of scaffolding services we provide across West Yorkshire and Manchester.</p>
      </header>

      <section className="services-list">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </section>

      {/* CTA Section */}
      <section className="services-cta">
        <h2>Need a Custom Solution?</h2>
        <p>Contact B&W Scaffolding today to discuss your project requirements and receive a free consultation.</p>
        <div className="cta-buttons">
          <a href="tel:07801753368" className="cta-button" onClick={playClick}>Call Us</a>
          <a href="mailto:b.wscaffoldingco@gmail.com" className="cta-button" onClick={playClick}>Email Us</a>
        </div>
      </section>

    </div>
  );
};

export default ServicesPage;